<template>
  <b-field :addons="addons" :grouped="grouped" :group-multiline="groupMultiline">
    <template #label v-if="$slots.label">
      <slot name="label" />
    </template>
    <slot />
  </b-field>
</template>

<script>
export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'FieldView',
  slotsDefinition: {
    label: {}
  },
  props: {
    addons: {
      type: Boolean,
      default: true
    },
    grouped: {
      type: Boolean,
      default: false
    },
    groupMultiline: {
      type: Boolean,
      default: false
    }
  }
};
</script>
